{
  "header": {
    "brandName": "SmartASS Agents"
  },
  "hero": {
    "badge": "AI автоматизация на работни процеси",
    "titleLine1": "Автоматизирайте бизнеса си",
    "titleLine2": "Без да пишете код",
    "description": "Създавайте интелигентни AI работни процеси визуално. Свържете инструментите си, автоматизирайте повтарящи се задачи и оставете умни AI агенти да водят разговорите с клиентите — всичко от една платформа.",
    "ctaDashboard": "Към таблото",
    "ctaStart": "Започнете безплатно",
    "benefit1": "Настройка за 5 минути",
    "benefit2": "Безплатно за начало",
    "benefit3": "Без начални такси",
    "scrollToExplore": "Скролирайте за повече"
  },
  "stats": {
    "fasterWorkflow": "По-бързо създаване на процеси",
    "hoursSaved": "Спестени часове месечно",
    "automated": "Автоматична наличност",
    "uptime": "Гарантирана наличност"
  },
  "features": {
    "tag": "Функции",
    "title": "Всичко необходимо за автоматизация",
    "subtitle": "Мощни функции, проектирани за бизнес потребители, не за програмисти. Създавайте, внедрявайте и мащабирайте с увереност.",
    "visualBuilder": "Визуален конструктор",
    "visualBuilderDesc": "Създавайте мощни автоматизации чрез просто плъзгане и пускане. Не е необходимо програмиране — всеки може да създаде сложни процеси за минути.",
    "visualBuilderTag": "Без код",
    "aiUnderstands": "AI, който разбира",
    "aiUnderstandsDesc": "Нашите интелигентни AI агенти учат от контекста и помнят разговорите. Получавайте умни отговори, които наистина имат смисъл за вашия бизнес.",
    "aiUnderstandsTag": "С AI",
    "integrations": "Безпроблемни интеграции",
    "integrationsDesc": "Свържете любимите си инструменти мигновено. Имейл, календари, CRM-и и още — всичко работи заедно автоматично.",
    "integrationsTag": "Свържете всичко",
    "security": "Корпоративна сигурност",
    "securityDesc": "Банково ниво на криптиране и GDPR съответствие, вградени в платформата. Вашите данни остават защитени с многослойна архитектура за сигурност.",
    "securityTag": "Сигурно"
  },
  "howItWorks": {
    "tag": "Как работи",
    "title": "Готови за минути",
    "subtitle": "Три прости стъпки за трансформация на работата ви",
    "step": "СТЪПКА",
    "step1Title": "Свържете инструментите си",
    "step1Desc": "Свържете съществуващите си бизнес инструменти с няколко клика. Поддържаме всички основни платформи.",
    "step2Title": "Създайте потока си",
    "step2Desc": "Плъзгайте и пускайте за създаване на перфектния работен процес. Не са нужни технически умения.",
    "step3Title": "Оставете AI да работи",
    "step3Desc": "Активирайте потока си и наблюдавайте как AI обработва задачи автоматично, 24/7."
  },
  "useCases": {
    "tag": "Приложения",
    "title": "Автоматизирайте най-важното",
    "subtitle": "От поддръжка на клиенти до продажби — вижте как екипи като вашия спестяват време всеки ден",
    "support": "Клиентска поддръжка",
    "supportDesc": "Автоматизирайте отговори, насочвайте запитвания интелигентно и решавайте проблеми по-бързо с AI чат.",
    "supportBenefit1": "24/7 наличност",
    "supportBenefit2": "Мигновени отговори",
    "supportBenefit3": "Умно насочване",
    "booking": "Резервация на срещи",
    "bookingDesc": "Оставете клиентите да резервират срещи автоматично. Без разменени имейли, само безпроблемно планиране.",
    "bookingBenefit1": "Синхронизация с календар",
    "bookingBenefit2": "Авто напомняния",
    "bookingBenefit3": "Множество часови зони",
    "email": "Имейл автоматизация",
    "emailDesc": "Изпращайте персонализирани имейли в мащаб. От кампании до транзакционни съобщения — всичко автоматизирано.",
    "emailBenefit1": "Шаблони",
    "emailBenefit2": "Персонализация",
    "emailBenefit3": "Проследяване",
    "leads": "Квалификация на лийдове",
    "leadsDesc": "Автоматично квалифицирайте и поддържайте лийдове. AI идентифицира горещите перспективи, за да може екипът ви да се фокусира върху приключването.",
    "leadsBenefit1": "Умно оценяване",
    "leadsBenefit2": "Авто проследяване",
    "leadsBenefit3": "CRM синхронизация"
  },
  "testimonials": {
    "tag": "Отзиви",
    "title": "Обичани от екипи навсякъде",
    "subtitle": "Вижте какво казват бизнес лидерите за нас",
    "quote1": "Намалихме времето за отговор от часове на секунди. Клиентите ни са възхитени!",
    "quote2": "Визуалният конструктор е революция. Изградих целия ни процес за лийдове за един следобед.",
    "quote3": "Най-накрая AI автоматизация, която наистина разбира контекста. Сякаш имаш умен асистент."
  },
  "enterprise": {
    "tag": "За корпорации",
    "title": "Създаден за мащаб и сигурност",
    "description": "Корпоративна инфраструктура, която расте с вашия бизнес. Мулти-тенант архитектура, GDPR съответствие и 99.9% гарантирана наличност.",
    "feature1": "Мулти-тенант изолация на данни",
    "feature2": "Ролеви контрол на достъпа",
    "feature3": "SOC 2 Type II съвместим",
    "feature4": "Криптиране от край до край",
    "feature5": "Специализирана поддръжка",
    "microservices": "14 Микросървиса",
    "workingTogether": "Работят заедно"
  },
  "cta": {
    "title": "Готови да трансформирате работния си процес?",
    "subtitle": "Присъединете се към хиляди компании, автоматизиращи операциите си със SmartAss AI. Започнете безплатно и мащабирайте по нужда.",
    "ctaDashboard": "Към таблото",
    "ctaStart": "Започнете безплатно",
    "contactSales": "Свържете се с продажби"
  },
  "footer": {
    "copyright": "© {{year}} Всички права запазени.",
    "tagline": "Корпоративна AI автоматизация на работни процеси"
  }
}
